export default [
  {
    path: "log/plan-out-of-stock",
    name: "PlanOutOfStock",
    component: () => import("@/pages/log/PlanOutOfStock.vue"),
    meta: {
      title: "计划断货日志",
      requireAuth: true,
    },
  },
  {
    path: "log/special-treatment-log",
    name: "SpecialTreatmentLog",
    component: () => import("@/pages/log/SpecialTreatmentLog/index.vue"),
    meta: {
      title: "特价治理日志",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/log.js